import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    name: 'account-signin',
    path: '/account/signin',
    component: () => import('./SignInApp.vue'),
    meta: {
      title: 'Sign in - Mezmo'
    }
  },
  {
    name: 'enterprise-signin',
    path: '/enterprise/signin',
    component: () => import('./SignInApp.vue'),
    meta: {
      title: 'Enterprise Sign in - Mezmo'
    }
  },
  {
    name: 'sso-signin',
    path: '/account/sso',
    component: () => import('./SignInApp.vue'),
    meta: {
      title: 'Single Sign-On - Mezmo'
    }
  },
  {
    name: 'forgot-password',
    path: '/account/forgot-password',
    component: () => import('client/components/account/ForgotPasswordApp.vue'),
    meta: {
      title: 'Reset password - Mezmo'
    }
  },
  {
    name: 'reset-password',
    path: '/account/reset-password',
    component: () => import('client/components/account/ResetPasswordApp.vue'),
    meta: {
      title: 'Create new password - Mezmo'
    }
  },
  {
    name: 'otp',
    path: '/auth/otp',
    component: () => import('client/components/auth/OtpApp.vue'),
    meta: {
      title: 'Two-factor Authentication - Mezmo'
    }
  },
  {
    name: 'account-setup',
    path: '/account/setup/:hmac',
    component: () => import('client/components/account/AccountSetupApp.vue'),
    meta: {
      title: 'Account setup - Mezmo'
    }
  },
  {
    name: 'verify-email',
    path: '/account/verify-email/:token?',
    component: () => import('client/components/account/VerifyEmailApp.vue'),
    meta: {
      title: 'Verify email - Mezmo'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
